import i18n from "i18next";
import {useEffect, useState, useRef} from "react";
import {Overlay, Tooltip} from "react-bootstrap";

export default function ShowFees({state, dispatch, bundle, label}) {

    const [show, setShow] = useState(false);
    const target = useRef(null);

    const toolTipStatus = (openOrClose) => {
        dispatch({ type: "anyTooltipsOpen", payload: { anyTooltipsOpen: openOrClose }});
        setShow(openOrClose);
    }

    return (
        <div className="show-fees" >
            {label}
            {bundle.usageFeesDescription &&
                <div className="d-inline">
                    <i className={bundle.usageFeesDescription ? "fal fa-question-circle" : "fal fa-question-circle disabled"} ref={target} onClick={() => toolTipStatus(true)}/>
                    <Overlay
                        placement="top"
                        trigger='click' rootClose
                        target={target.current}
                        onHide={() => toolTipStatus(false)}
                        show={show}
                    >
                        <Tooltip id={`bundle-tooltip`}>
                            <i className="fa fa-times d-flex justify-content-end"
                               onClick={() => toolTipStatus(false)}
                            />
                            <div className="bundle-tooltip-text" dangerouslySetInnerHTML={{
                                __html: bundle.usageFeesDescription
                            }}>
                            </div>
                        </Tooltip>
                    </Overlay>
                </div>
            }
        </div>
    )
}
